import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 41,
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M33.5 19.22V20.508C33.4983 23.527 32.5557 26.4646 30.8126 28.8826C29.0695 31.3006 26.6194 33.0695 23.8277 33.9255C21.036 34.7815 18.0523 34.6787 15.3215 33.6324C12.5908 32.5862 10.2593 30.6525 8.6748 28.1199C7.09031 25.5873 6.33772 22.5913 6.52926 19.5788C6.72081 16.5664 7.84623 13.6989 9.73768 11.4039C11.6291 9.10896 14.1853 7.50955 17.0249 6.84422C19.8644 6.17889 22.8354 6.48329 25.4945 7.71201",
		stroke: "#46B361",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M33.5 8.5L19.6538 22.5L15.5 18.3042",
		stroke: "#46B361",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSuccess;
